import {
  SUPPLIER_ROLES,
  PERMISSIONS,
  INTEGRATION_PERMISSIONS,
} from 'constants/all';

import { featureFlagKeys } from 'modules/common/drawers/featureFlagDrawer/const/featureFlagKeys';

import {
  getFeatureFlagValue,
  getGroupMemberSupplierRoles,
  isSuperUserOrGroupAdmin,
} from 'store/session/selectors';

export const isAccountingAccessible = (state) =>
  getGroupMemberSupplierRoles(state)[SUPPLIER_ROLES.ACCOUNTING] !==
  PERMISSIONS.NO_ACCESS;

export const isAccountingReadOnly = (state) =>
  getGroupMemberSupplierRoles(state)[SUPPLIER_ROLES.ACCOUNTING] ===
  PERMISSIONS.READ_ONLY;

export const isCompanySettingsAccessible = (state) =>
  getGroupMemberSupplierRoles(state)[SUPPLIER_ROLES.SUPPLIER_SETTINGS] !==
  PERMISSIONS.NO_ACCESS;

export const isCompanySettingsReadOnly = (state) =>
  getGroupMemberSupplierRoles(state)[SUPPLIER_ROLES.SUPPLIER_SETTINGS] ===
  PERMISSIONS.READ_ONLY;

export const isDigiQuoteSettingsAccessible = (state) =>
  getGroupMemberSupplierRoles(state)[SUPPLIER_ROLES.DIGI_QUOTE_SETTINGS] !==
  PERMISSIONS.NO_ACCESS;

export const isDigiQuoteSettingsReadOnly = (state) =>
  getGroupMemberSupplierRoles(state)[SUPPLIER_ROLES.DIGI_QUOTE_SETTINGS] ===
  PERMISSIONS.READ_ONLY;

export const isIntegrationsSettingsAccessible = (state) =>
  isSuperUserOrGroupAdmin(state) ||
  getGroupMemberSupplierRoles(state)[SUPPLIER_ROLES.INTEGRATIONS] !==
    PERMISSIONS.NO_ACCESS;

export const isIntegrationsSettingsReadOnly = (state) =>
  getGroupMemberSupplierRoles(state)[SUPPLIER_ROLES.INTEGRATIONS] ===
  PERMISSIONS.READ_ONLY;

export const isIntegrationsDetailPageAccessible = (state) => {
  return (
    isSuperUserOrGroupAdmin(state) ||
    (getGroupMemberSupplierRoles(state)[SUPPLIER_ROLES.INTEGRATIONS] ===
      INTEGRATION_PERMISSIONS.CONFIGURE &&
      getFeatureFlagValue(state, featureFlagKeys.isIntegrationsUiEnabled))
  );
};
